import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeService } from '../services/date-time.service';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {

  constructor(
    private readonly dateTimeService: DateTimeService,
  ) { }

  transform(value: string | undefined): unknown {
    // console.log('converting to: ', this.profileService.timezone);
    if(value) {
      return this.dateTimeService.acvDateFormat(value);
    }
    return '-';
  }
}
